export default {
  data() {
    return {
      displayStatus: "",
      headline: {
        en: "",
        jp: ""
      },
      step: ""
    };
  },

  methods: {
    showHeadline() {
      this.displayStatus = "headline";

      setTimeout(() => {
        this.displayStatus = "contents";
      }, 4000);
    }
  }
};
